import React from "react";
import ExportWidgetPlug from "views/components/widgets/ExportWidgetAction/ExportWidgetPlug";
import useWidgetExportActionComponent from "views/components/widgets/useWidgetExportActionComponent";
const ExportWidgetActionDelegate = ({ widget, contexts, disabled }) => {
  const ExportActionComponent = useWidgetExportActionComponent(widget);
  return !ExportActionComponent ? /* @__PURE__ */ React.createElement(ExportWidgetPlug, null) : /* @__PURE__ */ React.createElement(ExportActionComponent, { widget, contexts, disabled });
};
export default ExportWidgetActionDelegate;
